import React from "react";
import styles from "./AssistantIntegrationsTab.module.css"
import {Button, ButtonState} from "../../../../elements/button/Button";
import {useAppDispatch} from "../../../../../app/hooks";
import {FormName, openForm} from "../../../../elements/formProvider/formSlice";
import {IntegrationCard} from "./card/IntegrationCard";
import {ALL_INTEGRATIONS, BotIntegrationData} from "./slice/integrationsSlice";

interface AssistantIntegrationsTabProps {
    publicBotId: string
    botIntegrationDataList: BotIntegrationData[]
}

export const AssistantIntegrationsTab: React.FC<AssistantIntegrationsTabProps> = ({
                                                                                      publicBotId,
                                                                                      botIntegrationDataList
                                                                                  }) => {

    const dispatch = useAppDispatch()
    const isAnyOtherIntegrationAvailable = ALL_INTEGRATIONS.length !== botIntegrationDataList.length

    const handleCreateAssistantClick = () => {
        dispatch(openForm({name: FormName.CONNECT_INTEGRATION, formProps: {publicBotId}}));
    }

    const AddIntegrationButton = isAnyOtherIntegrationAvailable && <Button
        title={"Add integration"}
        iconSrc={"/plusIcon.svg"}
        state={ButtonState.PRIMARY}
        handleClick={handleCreateAssistantClick}
    />

    if (botIntegrationDataList.length !== 0) {
        return <div className={styles.wrapper}>
            <div className={styles.header}>
                {AddIntegrationButton}
            </div>
            <div className={styles.cardsWrapper}>
                {botIntegrationDataList.map(integration => {
                    return <IntegrationCard
                        fullData={integration.data}
                        publicBotId={publicBotId}
                        integration={integration.integration}
                        configurationId={integration.data.id}
                    />
                })}
            </div>
        </div>
    } else {
        return <div className={styles.noIntegrationsWrapper}>
            <div className={styles.titleWrapper}>
                <span className={styles.title}>No external channels connected yet</span>
                <span
                    className={styles.subtitle}>Connect this Assistant to an external communication channel to get started. Once you set one up, it will appear here.</span>
            </div>
            {AddIntegrationButton}
        </div>
    }
}
